import { useState, useEffect } from 'react';
import { setItem, getItem } from './mapSessionStorage';

function usePersistedState<T>(key: string, initialValue: T) {
  const [state, setState] = useState<T>(() => {
    return getItem(key) ?? initialValue;
  });

  useEffect(() => {
    setItem(key, state);
  }, [key, state]);

  return [state, setState] as const;
}

export default usePersistedState;